export default __webpack_public_path__ + "static/media/GooglePlay.5bfe47d9.jpg";